<template>

	<transition-group 
		name="alert" 
		tag="div"
		enter-active-class="animate__animated animate__fadeIn animate__faster"
		leave-to-class="animate__animated animate__fadeOut animate__faster"
	> 
		<div key="1" class="featherlight" v-if="shouldShow==true" style="display: block;" v-on:click.self="toggleSupplierActivityForm()">
			<div class="featherlight-content" id="supplier_activity_form" >
				<button class="featherlight-close-icon featherlight-close" aria-label="Close" v-on:click.self="toggleSupplierActivityForm()">✕</button>
				<section class="popup_content featherlight-inner section" style="max-width: 45rem;">
					<div class="constraint">

						<template v-if="action=='accept'">
							<div class="form_style">
								<h2>Accept Booking</h2>
								<p><span>
									<b>{{ item.full_name }}</b><br>
									{{ item.formatted_activity_date_time }}
								</span></p>
								<p>
									<label for="name" class="required">To accept this booking please enter your name</label>
									<input type="text" id="name" name="name" placeholder="" v-model="name" :class="{ error: errors.name }">
									<span v-if="errors.name" class="validation-error">{{ errors.name[0] }}</span>
								</p>
								<p>
									<button type="submit" class="button solid arrow wide medium" :class="{spinner: busy}" :disabled="busy" v-on:click="submitForm()" style="width: max-content; margin-left: auto;">Save</button>
								</p>
							</div>
						</template>

						<template v-if="action=='decline'">
							<div class="form_style">
								<h2>Decline Booking</h2>
								<p><span>
									<b>{{ item.full_name }}</b><br>
									{{ item.formatted_activity_date_time }}
								</span></p>
								<p>
									<label for="reason" class="required">Please enter a reason for declining this booking</label>
									<textarea id="reason" name="reason" placeholder="" v-model="reason" :class="{ error: errors.reason }" rows="3"></textarea>
									<span v-if="errors.reason" class="validation-error">{{ errors.reason[0] }}</span>
								</p>
								<p>
									<button type="submit" class="button solid arrow wide medium" :class="{spinner: busy}" :disabled="busy" v-on:click="submitForm()" style="width: max-content; margin-left: auto;">Save</button>
								</p>
							</div>
						</template>

						<template v-if="action=='time'">
							<div class="form_style">
								<h2>Suggest Different Time</h2>
								<p><span>
									<b>{{ item.full_name }}</b><br>
									{{ item.formatted_activity_date_time }}
								</span></p>
								<p>
									<label for="reason" class="required">Please suggest a time</label>
									<input type="time" id="time" name="time" placeholder="" v-model="time" :class="{ error: errors.time }" style="width: 100%;">
									<span v-if="errors.time" class="validation-error">{{ errors.time[0] }}</span>
								</p>
								<p>
									<button type="submit" class="button solid arrow wide medium" :class="{spinner: busy}" :disabled="busy" v-on:click="submitForm()" style="width: max-content; margin-left: auto;">Save</button>
								</p>
							</div>
						</template>
					</div>
				</section>
			</div>
		</div>
	 </transition-group>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	
	props: [
	],

	data: () => {
		return {
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			shouldShow: false,
			success: false,
			errors: [],
			uuid: null,
			item: null,
			action: null,
			name: '',
			reason: '',
			time: null,
			busy: false,
		}
	},

	computed: {
	},

	watch: {
		action: function (value) {
			if(value=='accept') { this.time = null; this.reason = ''; }
			if(value=='decline') { this.name = ''; this.time = null; }
			if(value=='time') { this.name = '' ;this.reason = ''; }
		}
	},

	created() {
	},

	mounted() {
	},

	methods: {

		...mapActions(['addAlert']),

		toggleSupplierActivityForm: function(uuid, item, action){
			if(this.shouldShow==true) {
				this.shouldShow = false;
				this.uuid = null;
				this.item = null;
				this.action = null;
				this.success = false;
				this.errors = [];
			}else{
				this.shouldShow = true;
				this.uuid = uuid
				this.item = item;
				this.action = action

				if(this.action=='time') {
					this.time = this.item.raw_activity_time;
				}
			}
		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		},

		submitForm: function() {
			var self = this;
			this.busy = true;
			axios.post('/ajax/postSupplierActivityForm', {
				uuid: this.uuid,
				item_id: this.item.id,
				action: this.action,
				name: this.name,
				reason: this.reason,
				time: this.time
			})
			.then(response => {
				this.busy = false;
				this.errors = [];
				this.shouldShow = false;
				var self = this;
				setTimeout(function() {
					if(self.action=='time'){
						self.$root.$refs['supplieractivitybuttons'+self.item.id].suggested_time=self.time;
						self.alert('<strong>Great!</strong> The suggested time has saved successfully', 'success');
					}
					if(self.action=='accept'){
						self.$root.$refs['supplieractivitybuttons'+self.item.id].status='Accepted';
						self.$root.$refs['supplieractivitybuttons' + self.item.id].suggested_time = null;
						self.alert('<strong>Success!</strong> The booking has now been accepted', 'success');
					}
					if(self.action=='decline'){
						self.$root.$refs['supplieractivitybuttons'+self.item.id].status='Declined';
						self.$root.$refs['supplieractivitybuttons'+self.item.id].suggested_time=null;
						self.alert('<strong>Success!</strong> The booking has now been declined', 'success');
					}
				}, 500);
			})
			.catch(error => {
				if(error.response.status == 422) {
					var errors = error.response.data['errors'];
					this.errors = errors;
					document.getElementById('supplier_activity_form').scrollIntoView({behavior: "smooth"});
					this.busy = false;
				}
			});
		},

		formatErrors: function(errors) {
			var msg = "";
			for (var e in errors) {
				msg += errors[e] + "<br>";
			}
			return msg;
		}

	}
};
</script>